import { apiEndPoints, apiMethods } from '../../../../../../utils/apiConstants'
import customAxios from '../../../../../../utils/customAxios'

export const getOrdersThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.allorders, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const getMobileOrdersThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.mobileOrders, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const cancelOrderThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.cancelOrder, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const refundOrderThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.refundOrder, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const replacementOrderThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.replacementOrder, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const gameInvogceHTMLThunk = async (id) => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.downloadGameInvoiceHTML(id))
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const getSpecificOrderDetailsThunk = async (data) => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.getSpecificOrderDetails(data))
		return { data: response.data }
	} catch (error) {
		throw error
	}
}
